import { useQuery } from 'react-query';
import request from '../helpers/request';

export const getCompanyHouses = async (companyId) => {
  return await request.get(
    `/Request/houses`,
    { companyId },
    'При загрузке списка домов для выбранной компании произошла ошибка'
  );
};

export const createCompanyHousesKeys = (companyId) => [
  'companyHouses',
  companyId,
];

const useCompanyHouses = (companyId, options) =>
  useQuery(
    createCompanyHousesKeys(companyId),
    () => getCompanyHouses(companyId),
    options
  );

export default useCompanyHouses;
